/**
 * Cadre d'affichage d'une vidéo selon son format (valeurs de l'énumération `VideoFormat`
 * côté API : 0 = paysage, 1 = portrait, 2 = carré, 3 = ultra-large).
 *
 * Partagé entre la sélection de templates et « Mes vidéos » : présenter une vidéo 16:9 dans
 * un cadre 9:16 la rognerait, et montrerait au client autre chose que ce que l'écran
 * diffusera. Une seule correspondance pour que les deux écrans ne divergent jamais.
 */
const FRAME_BY_FORMAT: Record<number, string> = {
  0: 'aspect-video',
  1: 'aspect-9/16',
  2: 'aspect-square',
  3: 'aspect-21/9',
};

/** Le portrait sert de repli : c'est le format par défaut du catalogue Pixlide. */
export function frameClassForFormat(format: number | undefined): string {
  return (format === undefined ? undefined : FRAME_BY_FORMAT[format]) ?? 'aspect-9/16';
}
